
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AdminLogin from "../pages/admin/login/page";
import AdminDashboard from "../pages/admin/dashboard/page";
import AdminMessages from "../pages/admin/messages/page";
import MessageCenterSettings from "../pages/admin/message-center-settings/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/admin/login",
    element: <AdminLogin />,
  },
  {
    path: "/admin/dashboard",
    element: <AdminDashboard />,
  },
  {
    path: "/admin/messages",
    element: <AdminMessages />,
  },
  {
    path: "/admin/message-center-settings",
    element: <MessageCenterSettings />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
